// POS SYSTEM Action's
import {
  GET_POS_SYSTEM_RENDER_DATA,
  GET_POS_SYSTEM_RENDER_DATA_SUCCESS,
  GET_POS_SYSTEM_RENDER_DATA_FAILURE,
  GET_POS_SYSTEM_LIST,
  GET_POS_SYSTEM_LIST_SUCCESS,
  GET_POS_SYSTEM_LIST_FAILURE,
  GET_POS_SYSTEM_DATA,
  GET_POS_SYSTEM_DATA_SUCCESS,
  GET_POS_SYSTEM_DATA_FAILURE,
  CREATE_POS_SYSTEM,
  CREATE_POS_SYSTEM_SUCCESS,
  CREATE_POS_SYSTEM_FAILURE,
  UPDATE_POS_SYSTEM,
  UPDATE_POS_SYSTEM_SUCCESS,
  UPDATE_POS_SYSTEM_FAILURE,
  DELETE_POS_SYSTEM,
  DELETE_POS_SYSTEM_SUCCESS,
  DELETE_POS_SYSTEM_FAILURE,
  GET_POS_SYSTEM_TO_USER_LIST,
  GET_POS_SYSTEM_TO_USER_LIST_SUCCESS,
  GET_POS_SYSTEM_TO_USER_LIST_FAILURE,
  GET_POS_SYSTEM_TO_USER_DATA,
  GET_POS_SYSTEM_TO_USER_DATA_SUCCESS,
  GET_POS_SYSTEM_TO_USER_DATA_FAILURE,
  CREATE_POS_SYSTEM_TO_USER,
  CREATE_POS_SYSTEM_TO_USER_SUCCESS,
  CREATE_POS_SYSTEM_TO_USER_FAILURE,
  UPDATE_POS_SYSTEM_TO_USER,
  UPDATE_POS_SYSTEM_TO_USER_SUCCESS,
  UPDATE_POS_SYSTEM_TO_USER_FAILURE,
  DELETE_POS_SYSTEM_TO_USER,
  DELETE_POS_SYSTEM_TO_USER_SUCCESS,
  DELETE_POS_SYSTEM_TO_USER_FAILURE,
  CREATE_POS_ORDER_PAYMENT_REQUEST,
  CREATE_POS_ORDER_PAYMENT_REQUEST_SUCCESS,
  CREATE_POS_ORDER_PAYMENT_REQUEST_FAILURE,
  CREATE_POS_ORDER_TENDER,
  CREATE_POS_ORDER_TENDER_SUCCESS,
  CREATE_POS_ORDER_TENDER_FAILURE,
  INTERNAL_TERMINAL_PAYMENT_RESULT,
  INTERNAL_TERMINAL_PAYMENT_RESULT_SUCCESS,
  INTERNAL_TERMINAL_PAYMENT_RESULT_FAILURE,
  INTERNAL_POS_SYSTEM_TICKETS_UPDATE,
  INTERNAL_POS_SYSTEM_TICKETS_UPDATE_SUCCESS,
  INTERNAL_POS_SYSTEM_TICKETS_UPDATE_FAILURE,
  GET_POS_SYSTEM_OVERVIEW,
  GET_POS_SYSTEM_OVERVIEW_SUCCESS,
  GET_POS_SYSTEM_OVERVIEW_FAILURE,
  PRINT_POS_ORDER_RECEIPT,
  PRINT_POS_ORDER_RECEIPT_SUCCESS,
  PRINT_POS_ORDER_RECEIPT_FAILURE,
  EMAIL_POS_ORDER_RECEIPT,
  EMAIL_POS_ORDER_RECEIPT_SUCCESS,
  EMAIL_POS_ORDER_RECEIPT_FAILURE,
  REFUND_POS_ORDER,
  REFUND_POS_ORDER_SUCCESS,
  REFUND_POS_ORDER_FAILURE,
  GET_POS_ORDER_LIST,
  GET_POS_ORDER_LIST_SUCCESS,
  GET_POS_ORDER_LIST_FAILURE,
  POS_ORDER_SEARCH,
  POS_ORDER_SEARCH_SUCCESS,
  POS_ORDER_SEARCH_FAILURE,
  GET_POS_ORDER_DATA,
  GET_POS_ORDER_DATA_SUCCESS,
  GET_POS_ORDER_DATA_FAILURE,
  CREATE_POS_ORDER,
  CREATE_POS_ORDER_SUCCESS,
  CREATE_POS_ORDER_FAILURE,
  UPDATE_POS_ORDER,
  UPDATE_POS_ORDER_SUCCESS,
  UPDATE_POS_ORDER_FAILURE,
  DELETE_POS_ORDER,
  DELETE_POS_ORDER_SUCCESS,
  DELETE_POS_ORDER_FAILURE,
  VOID_POS_ORDER_PAYMENT_REQUEST,
  VOID_POS_ORDER_PAYMENT_REQUEST_SUCCESS,
  VOID_POS_ORDER_PAYMENT_REQUEST_FAILURE,
} from "./actionType";

export const getPosSystemRenderData = (data) => ({
  type: GET_POS_SYSTEM_RENDER_DATA,
  payload: data,
});

export const getPosSystemRenderDataSuccess = (data) => ({
  type: GET_POS_SYSTEM_RENDER_DATA_SUCCESS,
  payload: data,
});

export const getPosSystemRenderDataFailure = (error) => ({
  type: GET_POS_SYSTEM_RENDER_DATA_FAILURE,
  payload: error,
});

export const getPosSystemList = () => ({
  type: GET_POS_SYSTEM_LIST,
});

export const getPosSystemListSuccess = (data) => ({
  type: GET_POS_SYSTEM_LIST_SUCCESS,
  payload: data,
});

export const getPosSystemListFailure = (error) => ({
  type: GET_POS_SYSTEM_LIST_FAILURE,
  payload: error,
});

export const getPosSystemData = (data) => ({
  type: GET_POS_SYSTEM_DATA,
  payload: data,
});

export const getPosSystemDataSuccess = (data) => ({
  type: GET_POS_SYSTEM_DATA_SUCCESS,
  payload: data,
});

export const getPosSystemDataFailure = (error) => ({
  type: GET_POS_SYSTEM_DATA_FAILURE,
  payload: error,
});

export const createPosSystem = (data) => ({
  type: CREATE_POS_SYSTEM,
  payload: data,
});

export const createPosSystemSuccess = (data) => ({
  type: CREATE_POS_SYSTEM_SUCCESS,
  payload: data,
});

export const createPosSystemFailure = (error) => ({
  type: CREATE_POS_SYSTEM_FAILURE,
  payload: error,
});

export const updatePosSystem = (data) => ({
  type: UPDATE_POS_SYSTEM,
  payload: data,
});

export const updatePosSystemSuccess = (data) => ({
  type: UPDATE_POS_SYSTEM_SUCCESS,
  payload: data,
});

export const updatePosSystemFailure = (error) => ({
  type: UPDATE_POS_SYSTEM_FAILURE,
  payload: error,
});

export const deletePosSystem = (data) => ({
  type: DELETE_POS_SYSTEM,
  payload: data,
});

export const deletePosSystemSuccess = (data) => ({
  type: DELETE_POS_SYSTEM_SUCCESS,
  payload: data,
});

export const deletePosSystemFailure = (error) => ({
  type: DELETE_POS_SYSTEM_FAILURE,
  payload: error,
});

export const getPosSystemToUserList = () => ({
  type: GET_POS_SYSTEM_TO_USER_LIST,
});

export const getPosSystemToUserListSuccess = (data) => ({
  type: GET_POS_SYSTEM_TO_USER_LIST_SUCCESS,
  payload: data,
});

export const getPosSystemToUserListFailure = (error) => ({
  type: GET_POS_SYSTEM_TO_USER_LIST_FAILURE,
  payload: error,
});

export const getPosSystemToUserData = (data) => ({
  type: GET_POS_SYSTEM_TO_USER_DATA,
  payload: data,
});

export const getPosSystemToUserDataSuccess = (data) => ({
  type: GET_POS_SYSTEM_TO_USER_DATA_SUCCESS,
  payload: data,
});

export const getPosSystemToUserDataFailure = (error) => ({
  type: GET_POS_SYSTEM_TO_USER_DATA_FAILURE,
  payload: error,
});

export const createPosSystemToUser = (data) => ({
  type: CREATE_POS_SYSTEM_TO_USER,
  payload: data,
});

export const createPosSystemToUserSuccess = (data) => ({
  type: CREATE_POS_SYSTEM_TO_USER_SUCCESS,
  payload: data,
});

export const createPosSystemToUserFailure = (error) => ({
  type: CREATE_POS_SYSTEM_TO_USER_FAILURE,
  payload: error,
});

export const updatePosSystemToUser = (data) => ({
  type: UPDATE_POS_SYSTEM_TO_USER,
  payload: data,
});

export const updatePosSystemToUserSuccess = (data) => ({
  type: UPDATE_POS_SYSTEM_TO_USER_SUCCESS,
  payload: data,
});

export const updatePosSystemToUserFailure = (error) => ({
  type: UPDATE_POS_SYSTEM_TO_USER_FAILURE,
  payload: error,
});

export const deletePosSystemToUser = (data) => ({
  type: DELETE_POS_SYSTEM_TO_USER,
  payload: data,
});

export const deletePosSystemToUserSuccess = (data) => ({
  type: DELETE_POS_SYSTEM_TO_USER_SUCCESS,
  payload: data,
});

export const deletePosSystemToUserFailure = (error) => ({
  type: DELETE_POS_SYSTEM_TO_USER_FAILURE,
  payload: error,
});

// POS ORDER Actions
export const getPosOrderList = () => ({
  type: GET_POS_ORDER_LIST,
});

export const getPosOrderListSuccess = (data) => ({
  type: GET_POS_ORDER_LIST_SUCCESS,
  payload: data,
});

export const getPosOrderListFailure = (error) => ({
  type: GET_POS_ORDER_LIST_FAILURE,
  payload: error,
});

export const posOrderSearch = (data) => ({
  type: POS_ORDER_SEARCH,
  payload: data,
});

export const posOrderSearchSuccess = (data) => ({
  type: POS_ORDER_SEARCH_SUCCESS,
  payload: data,
});

export const posOrderSearchFailure = (error) => ({
  type: POS_ORDER_SEARCH_FAILURE,
  payload: error,
});

export const getPosOrderData = (data) => ({
  type: GET_POS_ORDER_DATA,
  payload: data,
});

export const getPosOrderDataSuccess = (data) => ({
  type: GET_POS_ORDER_DATA_SUCCESS,
  payload: data,
});

export const getPosOrderDataFailure = (error) => ({
  type: GET_POS_ORDER_DATA_FAILURE,
  payload: error,
});

export const createPosOrder = (data) => ({
  type: CREATE_POS_ORDER,
  payload: data,
});

export const createPosOrderSuccess = (data) => ({
  type: CREATE_POS_ORDER_SUCCESS,
  payload: data,
});

export const createPosOrderFailure = (error) => ({
  type: CREATE_POS_ORDER_FAILURE,
  payload: error,
});

export const updatePosOrder = (data) => ({
  type: UPDATE_POS_ORDER,
  payload: data,
});

export const updatePosOrderSuccess = (data) => ({
  type: UPDATE_POS_ORDER_SUCCESS,
  payload: data,
});

export const updatePosOrderFailure = (error) => ({
  type: UPDATE_POS_ORDER_FAILURE,
  payload: error,
});

export const deletePosOrder = (data) => ({
  type: DELETE_POS_ORDER,
  payload: data,
});

export const deletePosOrderSuccess = (data) => ({
  type: DELETE_POS_ORDER_SUCCESS,
  payload: data,
});

export const deletePosOrderFailure = (error) => ({
  type: DELETE_POS_ORDER_FAILURE,
  payload: error,
});

export const createPosOrderPaymentRequest = (data) => ({
  type: CREATE_POS_ORDER_PAYMENT_REQUEST,
  payload: data,
});

export const createPosOrderPaymentRequestSuccess = (data) => ({
  type: CREATE_POS_ORDER_PAYMENT_REQUEST_SUCCESS,
  payload: data,
});

export const createPosOrderPaymentRequestFailure = (error) => ({
  type: CREATE_POS_ORDER_PAYMENT_REQUEST_FAILURE,
  payload: error,
});

export const createPosOrderTender = (data) => ({
  type: CREATE_POS_ORDER_TENDER,
  payload: data,
});

export const createPosOrderTenderSuccess = (data) => ({
  type: CREATE_POS_ORDER_TENDER_SUCCESS,
  payload: data,
});

export const createPosOrderTenderFailure = (error) => ({
  type: CREATE_POS_ORDER_TENDER_FAILURE,
  payload: error,
});

export const internalTerminalPaymentResult = (data) => ({
  type: INTERNAL_TERMINAL_PAYMENT_RESULT,
  payload: data,
});

export const internalTerminalPaymentResultSuccess = (data) => ({
  type: INTERNAL_TERMINAL_PAYMENT_RESULT_SUCCESS,
  payload: data,
});

export const internalTerminalPaymentResultFailure = (error) => ({
  type: INTERNAL_TERMINAL_PAYMENT_RESULT_FAILURE,
  payload: error,
});


//GET_POS_SYSTEM_OVERVIEW
export const getPosSystemOverview = (data) => ({
  type: GET_POS_SYSTEM_OVERVIEW,
    payload: data,
});

export const getPosSystemOverviewSuccess = (data) => ({
  type: GET_POS_SYSTEM_OVERVIEW_SUCCESS,
  payload: data,
});

export const getPosSystemOverviewFailure = (error) => ({
  type: GET_POS_SYSTEM_OVERVIEW_FAILURE,
  payload: error,
});

//VOID_POS_ORDER_PAYMENT_REQUEST
export const voidPosOrderPaymentRequest = (data) => ({
  type: VOID_POS_ORDER_PAYMENT_REQUEST,
  payload: data,
});

export const voidPosOrderPaymentRequestSuccess = (data) => ({
  type: VOID_POS_ORDER_PAYMENT_REQUEST_SUCCESS,
  payload: data,
});

export const voidPosOrderPaymentRequestFailure = (error) => ({
  type: VOID_POS_ORDER_PAYMENT_REQUEST_FAILURE,
  payload: error,
});

export const printPosOrderReceipt = (data) => ({
  type: PRINT_POS_ORDER_RECEIPT,
  payload: data,
});

export const printPosOrderReceiptSuccess = (data) => ({
  type: PRINT_POS_ORDER_RECEIPT_SUCCESS,
  payload: data,
});

export const printPosOrderReceiptFailure = (error) => ({
  type: PRINT_POS_ORDER_RECEIPT_FAILURE,
  payload: error,
});

export const emailPosOrderReceipt = (data) => ({
  type: EMAIL_POS_ORDER_RECEIPT,
  payload: data,
});

export const emailPosOrderReceiptSuccess = (data) => ({
  type: EMAIL_POS_ORDER_RECEIPT_SUCCESS,
  payload: data,
});

export const emailPosOrderReceiptFailure = (error) => ({
  type: EMAIL_POS_ORDER_RECEIPT_FAILURE,
  payload: error,
});

export const refundPosOrder = (data) => ({
  type: REFUND_POS_ORDER,
  payload: data,
});

export const refundPosOrderSuccess = (data) => ({
  type: REFUND_POS_ORDER_SUCCESS,
  payload: data,
});

export const refundPosOrderFailure = (error) => ({
  type: REFUND_POS_ORDER_FAILURE,
  payload: error,
});